function getAspectRatio(width, height) {
    var ratio = width / height;
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4by3' : '16by9';
}

var defaultSetting = {
    // themes: 'default',
    // highlight: true,
    category: ['1', '2']
}

var setting = $.extend({}, defaultSetting, userSetting);

var demun = {

    // 옵션여부에 관계없이 실행되는 함수
    init: function () {
        // 코드 구문강조
        // if (setting.highlight) {
        //     console.log('highligh 정상호출22');
        //     hljs.initHighlightingOnLoad();
        //     // hljs.initLineNumbersOnLoad();
        //     // $('code.hljs').each(function (i, block) {
        //     //     hljs.lineNumbersBlock(block);
        //     // });
        // }

        // if (setting.themes) {
        //     this.theme();
        // }
        if (setting.category) {
            this.categoryExpend();
        }

        this.tistoryCode();
        this.thumb();
        this.openMenu();
        this.toolbar();
        this.topBtn();
        this.login();
        this.imageblock();
        this.iframeRaito();

    },
    // 티스토리 치환자 [/## 를 [## 치환
    tistoryCode: function () {
        var pre = $('pre'),
            code = $('code');
        if ((pre) || (code)) {
            //티스토리 치환자 pre
            (function () {
                function l(o) {
                    return o.replace(/\[#\\#/g, "[##").replace(/<br\s*\/?>|<br\s*\/?>/gi, "");
                }
                var m = document.getElementsByTagName('pre'),
                    k = m.length,
                    n;
                for (i = 0; i < k; i += 1) {
                    n = m[i];
                    n.innerHTML = l(n.innerHTML);
                }
            }());
            //티스토리 치환자 code
            (function () {
                function c(o) {
                    return o.replace(/\[#\\#/g, "[##").replace(/<br\s*\/?>|<br\s*\/?>/gi, "");
                }
                var m = document.getElementsByTagName('code'),
                    k = m.length,
                    n;
                for (i = 0; i < k; i += 1) {
                    n = m[i];
                    n.innerHTML = c(n.innerHTML);
                }
            }());

        };
    },

    // 검색리스트에서 썸네일 이미지 있는지 확인
    thumb: function () {
        $('.thumb-link').each(function () {
            if ($(this).children('.thumb').length === 0) {
                $(this).children('.thumb-body').addClass('wide');
            }
        });
    },

    // 모바일 메뉴 열고 닫기
    openMenu: function () {
        var openBtn = $('#openMenu');
        var blogMenu = $('#blogMenu');

        openBtn.on('click', function () {
            if (blogMenu.css('display') === 'none') {
                blogMenu.slideDown(200);
            } else {
                blogMenu.slideUp(200);
            }
        });
    },

    // tistorytoolbarid, 테터데스크 판단하여 여백확보
    toolbar: function () {
        var ttbar = $('#tistorytoolbarid');
        var ttadmin = $('#ttDesk_adminbtn');
        if (ttbar.length > 0 && ttadmin.length === 0) {
            $('body').css('padding-top', '25px');
        } else if (ttbar.length === 0 && ttadmin.length > 0) {
            $('body').css('padding-top', '54px');
        } else if (ttbar.length > 0 && ttadmin.length > 0) {
            $('body').css('padding-top', '70px');
        }
    },

    // 카테고리 리스트 접고 펼치기
    categoryExpend: function () {
        var tt = $('.tt_category');
        var allView = $('.link_tit');
        var item = $('.link_item');
        var subItem = $('.link_sub_item');
        var fold = false;

        // 전체보기메뉴 버튼추가
        allView.before('<a href="javascript:;" class="btn-all down"></a>');

        // 설정에서 지정한 펼침폴더 보이기
        function catExpend($this) {
            $this.before('<a href="javascript:;" class="btn-category minus"></a>');
            $this.siblings('.sub_category_list').show();
        }

        item.each(function (index, el) {
            var $this = $(this);
            // setting.category.length 가 있을때만 보이기
            if (setting.category.length > 0) {

                if (setting.category[0] == index) {
                    catExpend($this);
                } else if (setting.category[1] == index) {
                    catExpend($this);
                } else if (setting.category[2] == index) {
                    catExpend($this);
                } else if (setting.category[3] == index) {
                    catExpend($this);
                } else if (setting.category[4] == index) {
                    catExpend($this);
                }
            }

            // plus, minus 아이콘 삽입
            if ($this.next('.sub_category_list').length > 0 && $this.next('.sub_category_list').css('display') === 'none') {
                $this.before('<a href="javascript:;" class="btn-category plus"></a>');
            } else if ($this.next('.sub_category_list').length === 0) {
                $this.before('<i class="btn-empty"></i>');
            } else {
                // // 위에서 펼친 메뉴
                // console.log('펼친 메뉴: ' + $this.html());
            }

        });

        // sub item 버튼 배치
        subItem.before('<i class="btn-right"></i>');

        // 플러스 버튼 클릭시 하위메뉴 보이기
        $('.category_list .btn-category.plus').on('click', function () {
            var list = $(this).siblings('.sub_category_list');
            if (list.css('display') === 'block') {
                list.slideUp(200);
                $(this).attr('class', 'btn-category plus');
            } else {
                list.slideDown(200);
                $(this).attr('class', 'btn-category minus');
            }
        });

        // 마이너스 버튼 클릭시 하위메뉴 보이기
        $('.category_list .btn-category.minus').on('click', function () {
            var list = $(this).siblings('.sub_category_list');
            if (list.css('display') === 'block') {
                list.slideUp(200);
                $(this).attr('class', 'btn-category plus');
            } else {
                list.slideDown(200);
                $(this).attr('class', 'btn-category minus');
            }
        });

        // 전체보기 버튼 클릭시 하위메뉴 펼침 숨김
        $('.tt_category .btn-all').on('click', function () {
            if (fold === true) {
                $('.sub_category_list').slideDown(200);
                $(this).attr('class', 'btn-all down');
                $('.tt_category .btn-category.plus').attr('class', 'btn-category minus');
                fold = false;
            } else {
                $('.sub_category_list').slideUp(200);
                $(this).attr('class', 'btn-all up');
                $('.tt_category .btn-category.minus').attr('class', 'btn-category plus');
                fold = true;
            }
        });
    },

    // top 으로 이동 버튼
    topBtn: function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $('.btn-top').fadeIn();
            } else {
                $('.btn-top').fadeOut();
            }
        });

        $("#btnTop").on('click', function () {
            $('html, body').animate({
                scrollTop: 0
            }, 400);
            return false;
        });
    },

    //로그인, 로그아웃 체크 : http://devsomnus.tistory.com/19 
    login: function () {
        var $body = $('body');
        var userState,
            userClass = 'no-tuser',
            $ttbar = $('#tistorytoolbarid');
        //userState - 0: not log in = no-tuser, 1: logged-in = tuser, 2: admin = tadmin 
        //length - 3: not log in, 4: logged-in
        userState = $ttbar.find('.tt_menubar_logout').children('.tt_menubar_link_tit').text().length - 3;
        if (userState) {
            userClass = 'tuser';
            var check = location.href.split('.com')[0] + ".com";
            $ttbar.find('.tt_menubar_link').each(function () {
                if ($(this).attr('href') == check) {
                    userState = 2;
                    userClass = 'tadmin';
                }
            });
        }
        $body.addClass(userClass);
    },

    // 본문 이미지 너비 100% 만들기
    imageblock: function () {
        // var article = $('.tt_article_useless_p_margin');
        var article = $('.article');
        var imageblock = article.find('.imageblock');

        imageblock.each(function (index, el) {
            var $this = $(this);
            var style = $this.parents().css('float');
            // 플롯된 이미지 블럭
            if (style === 'left' || style === 'right') {
                $this.css('width', '100%');
                $this.find('.cap1').css('width', '100%');
            }

            // table 안에 이미지블럭
            if ($this.closest('table')) {
                $this.closest('table').addClass('table_add');
                $this.closest('table').find('.imageblock').css('width', '100%');
                $this.closest('table').find('.imageblock').children('img').css('width', 'auto');
                $this.closest('table').find('.cap1').css('width', '100%');
            }
        });

    },

    // ifram 동영상, 지도 너비 설정
    iframeRaito: function () {
        $('.article iframe[src*="proxy/plusmapViewer.php"], .article iframe[src*="play-tv.kakao.com"], .article iframe[src*="player.vimeo.com"], .article iframe[src*="//www.youtube.com"], .article iframe[src*="//videofarm.daum.net"], .article .iframe-player').each(function () {
            var $this = $(this);

            if (!($this.parent().hasClass('embed-responsive'))) {
                var ewd = $this.attr('width') ? parseInt($this.attr('width')) : $this.width();
                var eht = $this.attr('height') ? parseInt($this.attr('height')) : $this.height();

                // if ($this.attr('width')) {
                //     var ewd = parseInt($this.attr('width'));
                // } else {
                //     var ewd = $this.width();
                // }

                // if ($this.attr('height')) {
                //     var eht = parseInt($this.attr('height'));
                // } else {
                //     var eht = $this.height();
                // }

                $this.css('width', '100%');

                var ratio = getAspectRatio(ewd, eht);
                $this.wrap('<div class="embed-wrapper" style="max-width:' + ewd + 'px"><div class="over-padding embed-responsive embed-responsive-' + ratio + '"></div></div>');
            }
        });
    },

    // 테마 적용
    theme: function () {
        if (setting.themes === 'blue') {
            $('body').addClass('blue');
        } else if (setting.themes === 'bluegrey') {
            $('body').addClass('bluegrey');
        } else if (setting.themes === 'brown') {
            $('body').addClass('brown');
        } else if (setting.themes === 'cyan') {
            $('body').addClass('cyan');
        } else if (setting.themes === 'dark') {
            $('body').addClass('dark');
        } else if (setting.themes === 'green') {
            $('body').addClass('green');
        } else if (setting.themes === 'grey') {
            $('body').addClass('grey');
        } else if (setting.themes === 'lime') {
            $('body').addClass('lime');
        } else if (setting.themes === 'orange') {
            $('body').addClass('orange');
        } else if (setting.themes === 'purple') {
            $('body').addClass('purple');
        } else if (setting.themes === 'teal') {
            $('body').addClass('teal');
        } else if (setting.themes === 'yellow') {
            $('body').addClass('yellow');
        } else {
            $('body').addClass('default');
        }
    }

};

